<template>
  <v-container pa-0 style="width: 794px;">
    <v-row class="ml-3 mt-n9" align="center" justify="center">
      <div class='headline'>{{ ticketTypes[typeId].name }}</div>
    </v-row>
    <v-alert border="left" colored-border type="info" elevation="1" width="100%" title="" icon="info">
      С июня 2024 заявки на подключения принимаются только от физических лиц.<br>
      Заявки от юридических лиц принимаются через через <a href="https://gosuslugi.primorsky.ru/pgu/categories/info.htm?id=19879@egClassification">портал Правительства Приморского Края</a>
    </v-alert>
    <v-form v-model="valid" lazy-validation ref="form">
      <v-row align="center" justify="center" class="mt-10">
        <v-card width="794">
          <component :isIndividual="isIndividual" ref="templ" v-bind:is="ticketTypes[typeId].component"></component>
        </v-card>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-checkbox v-model="consent" :rules="[v => !!v || 'Для сохранения заявки необходимо согласие на обработку персональных данных']" label="Даю согласие на обработку персональных данных бессрочно" required></v-checkbox>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12">
          <v-alert border="right" colored-border type="error" elevation="2" v-if="!(hideAlert || valid)">
            Не все поля заявки заполнены верно
          </v-alert>
          <v-spacer></v-spacer>
        </v-col>
        <v-col cols="12" align="center" justify="center">
          <v-btn color="accent" @click="validate" width="300" :disabled="isDisabled" large>Отправить</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <request-dialog v-model="searchDialog" message="Выполняется запрос..." />
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CreateTicket',

  components: {
    TeploTemplate: () => import(
      '@/components/tickets/TeploTemplate'
    ),
    ColdWaterTemplate: () => import(
      '@/components/tickets/ColdWaterTemplate'
    ),
    HotWaterTemplate: () => import(
      '@/components/tickets/HotWaterTemplate'
    ),
    TechTemplate: () => import(
      '@/components/tickets/TechTemplate'
    ),
  },

  props: {
    typeId: {
      type: Number,
      default: undefined
    },
    isIndividual: {
      default: undefined
    }
  },

  data: () => ({
    searchDialog: false,
    template: null,
    consent: undefined,
    valid: true,
    isDisabled: false,
    hideAlert: true
  }),

  computed: {
    ...mapGetters({
      ticketTypes: 'common/ticketTypes'
    })
  },

  methods: {
    submitTicket: async function() {
      this.searchDialog = true
      this.isDisabled = true
      try {
        let data = await this.$refs.templ.formData
        if (this.typeId != 4) {
          if (typeof this.isIndividual === "boolean") {
            data['is_individual'] = this.isIndividual
          } else {
            data['is_individual'] = this.isIndividual == 'true'
          }
        }
        data['type_id'] = this.typeId
        const resp = await this.$api.Account.submitTicket(data)
        this.searchDialog = false
        this.$router.push({ path: `/tickets/my_tickets/${resp.data['code']}` })
      } catch (e) {
        const err = e
        this.isDisabled = false
        this.searchDialog = false
        let error = 'Не удалось сохранить заявку. Попробуйте повторить запрос позднее'
        await this.$store.dispatch('notification/setSystemNotification', { message: error, type: 'error' })
        console.error(e)
      }
    },
    validate() {
      let isValid = this.$refs.form.validate()
      this.hideAlert = isValid
      if (isValid) {
        this.submitTicket()
      }
    },
  }
}
</script>